import default_logo from 'assets/img/logo.svg';
import { pick } from 'lodash';
import api from 'utils/api';

const transformPartner = (raw) => ({
  id: raw?.data?.uuid,
  name: raw?.data?.name || 'GameBox',
  account_logo: raw?.data?.themes?.logo_url || default_logo,
  account_label: raw?.data?.themes?.account_label || 'GameBox Account',
  is_white_labeled: raw?.data?.is_white_labeled ?? false,
  bg_lobby_url: raw?.data?.themes?.lobby_bg_url,
  bg_login_url: raw?.data?.themes?.login_bg_url,
  status: raw?.data?.status,
  colors: pick(raw?.data?.themes || {}, [
    '--primary-50',
    '--primary-100',
    '--primary-200',
    '--primary-300',
    '--primary-400',
    '--primary-500',
    '--primary-600',
    '--primary-700',
    '--primary-800',
    '--primary-900',
  ]),
  theme: raw?.data?.themes?.theme,
});

export const transformSession = (raw) => ({
  token: raw?.data?.token,
});

export const getPartnerById = (id, setter) => {
  api
    .get(`/partner_mng/v1/partner/uuid/${id}`, { transform: transformPartner })
    .then(setter);
};

const transformAuthUrl = (raw) => ({
  redirect_url: raw?.data?.auth_url,
});

export const getAuthUrl = (id, setter) => {
  // api.get(`/partner_mng/v1/partner/uuid/${id}`, { transform: transformAuthUrl }).then(setter);
  api
    .get(`/gamebox_subscriber/v1/oauth/redirect?partner_uuid=${id}`, {
      transform: transformAuthUrl,
    })
    .then(setter);
};

export const getSessionByCode = (code, setter) => {
  api
    .post(`/gamebox_subscriber/v1/authenticate/code`, {
      payload: { code },
      transform: transformSession,
    })
    .then(setter);
};

export const logout = (payload, setter) => {
  api
    .remove(`/auth/v1/logout`, {
      payload,
      session: true,
    })
    .then(setter);
};
